import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DocumentClient, Documents, DocumentTypeClient, DocumentTypes, Material, MaterialClient, NServices, ServiceClient, Unit, VIKUnitClient} from "src/app/web-api-client";
import { forkJoin } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MaterialsCreationComponent } from "./materials-creation/materials-creation.component";
import { MaterialEditComponent } from "./materials-edit/materials-edit.component";
import { ConfirmModalComponent } from "../../../../modals/confirm-modal/confirm-modal.component";
import { UnSuccessModalComponent } from "../../../../modals/failed-modal/failed-modal.component";


@Component({
  selector: 'app-materials',
  templateUrl: './materials.component.html',
  styleUrls: ['./materials.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class MaterialsComponent implements OnInit {

  public isLoaded: boolean = false;
  public selectedService: Material;
  public services: Material[];
  private dTypes: Unit[];

  public searchQuery: string = '';
  public filteredServices: Material[] = [];


  constructor(private readonly changeDetectionRef:ChangeDetectorRef, private readonly modalService: NgbModal,public client:MaterialClient,public units:VIKUnitClient){

  }

  ngOnInit(): void {

    this.LoadData();

    //this.client.getList().subscribe((allDocs:Documents[])=>{
    //  this.services = allDocs;
    //  this.isLoaded = true;
    //  this.changeDetectionRef.detectChanges();
    //});

  }

  private LoadData() {
    this.isLoaded = false;
        forkJoin([this.client.getList(), this.units.getList()])
            .subscribe(([documents, documentTypes]) => {

              this.services = documents;
              this.filteredServices = documents;
                this.dTypes = documentTypes;

                this.isLoaded = true;
                this.changeDetectionRef.detectChanges();

            });
    }

  public getDocTypeName(docTypeId: number): string {
    return this.dTypes.find(d => d.isActive ==true && d.id == docTypeId)?.title;
  }
   

 public onSelected(service:Material){
   if (this.isSelected(service)){
    this.selectedService = null;
  }
  else{

     this.selectedService = service;
  }
 }

  public isSelected(service: Material):boolean{
   return this.selectedService == service;
 }

public onCreation():void{
  let modalRef =this.modalService.open(MaterialsCreationComponent, {});

  modalRef.componentInstance.onClose.subscribe(r => {

    this.LoadData();

  });

}


public onDelete(): void { 
  let modalRef = this.modalService.open(ConfirmModalComponent);

  modalRef.componentInstance.onClose.subscribe(result => {
    if (result === true) {

      this.client.remove(this.selectedService.id).subscribe(r => {
        this.services = this.services.filter(d => d.id != this.selectedService.id);
        this.filteredServices = this.services.slice(0);
        this.changeDetectionRef.detectChanges();
      })
    }
    else {
      this.modalService.open(UnSuccessModalComponent);
    }
  });

  }

  public onEdit(): void {

    let modalRef = this.modalService.open(MaterialEditComponent);
    modalRef.componentInstance.editObject = this.selectedService;

    modalRef.componentInstance.onClose.subscribe(r => {

      this.LoadData();

    });
    }
     

  public GetBoolean(val: boolean): string {

    return val ? 'Да' : 'Не';
    
  }

  filterServices() {
    if (this.searchQuery) {
      this.filteredServices = this.services.filter(service =>
        service.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.description.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredServices = this.services;
    }
  }


  getUnit(material: Material): string {

    return this.dTypes.find(d => d.id == material.unitId).title;
  }
}
